import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button } from 'reactstrap'
import { useNavigate } from 'react-router-dom'
import Header from '../components/Header'
import DistributorsListCard from '../components/distributors/DistributorsListCard'
import apiDistributorService from '../services/apiDistributorService'
import '../styles/FormView.css'

function DistributorsView() {
  const navigate = useNavigate()
  const role = (sessionStorage.getItem('role') || '').toUpperCase()
  const canManage = role !== 'DISTRIBUTOR'
  const [distributors, setDistributors] = useState([])
  const [page, setPage] = useState(0)
  const [size, setSize] = useState(10)
  const [totalPages, setTotalPages] = useState(0)
  const [totalElements, setTotalElements] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')

  const loadDistributors = async (nextPage = page, nextSize = size) => {
    setIsLoading(true)
    setError('')
    try {
      const data = await apiDistributorService.listDistributors(nextPage, nextSize)
      const pageInfo = data?.page || {}
      setDistributors(Array.isArray(data?.content) ? data.content : [])
      setPage(typeof pageInfo?.number === 'number' ? pageInfo.number : nextPage)
      setSize(typeof pageInfo?.size === 'number' ? pageInfo.size : nextSize)
      setTotalPages(typeof pageInfo?.totalPages === 'number' ? pageInfo.totalPages : 0)
      setTotalElements(typeof pageInfo?.totalElements === 'number' ? pageInfo.totalElements : 0)
    } catch (err) {
      setError(err?.body?.message || 'No se pudieron cargar los distribuidores.')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    loadDistributors(0, size)
  }, [size])

  return (
    <>
      <Header />
      <Container fluid className="form-container">
        <Container>
          <div className="form-header">
            <h1>Distribuidores</h1>
          </div>
          <Row className="justify-content-center mt-4">
            <Col xs={12} lg={10}>
              {canManage && (
                <div className="d-flex justify-content-end mb-3">
                  <Button color="success" onClick={() => navigate('/distributors/add')}>
                    Añadir distribuidor
                  </Button>
                </div>
              )}
              <DistributorsListCard
                distributors={distributors}
                isLoading={isLoading}
                error={error}
                onRefresh={() => loadDistributors(page, size)}
                onEdit={(distributor) => navigate(`/distributors/edit/${distributor.id}`, { state: { distributor } })}
                canEdit={canManage}
                page={page}
                totalPages={totalPages}
                totalElements={totalElements}
                size={size}
                onPageChange={(nextPage) => loadDistributors(nextPage, size)}
                onSizeChange={(nextSize) => setSize(nextSize)}
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  )
}

export default DistributorsView
